<template>
    <div class="container-fluid layout-wrapper">
        <!--<div class="row text-center">-->
        <!--<div class="col-lg-4 col-12 mt-2 d-inline-block">-->
        <!--<div class="input-group round">-->
        <!--<div class="input-group-prepend">-->
        <!--<span class="input-group-text">شماره سند :</span>-->
        <!--</div>-->
        <!--<vs-select :data="providers" :mode="'create'"-->
        <!--:header="{multiple: false, label: 'outSourceName'}"-->
        <!--@onChange="onChange"></vs-select>-->
        <!--</div>-->
        <!--</div>-->

        <!--<div class="col-lg-8 col-12 mt-2">-->
        <!--<div class=" d-inline-block mb-3">-->
        <!--<div class="input-group round">-->
        <!--<div class="input-group-prepend">-->
        <!--<span class="input-group-text">از تاریخ</span>-->
        <!--</div>-->
        <!--<date-picker type="date" class="date-picker" format="jYYYY-jMM-jDD" :auto-submit="true"-->
        <!--@input="onStartDatePicked" ref="datePickerStart"-->
        <!--style="flex: 1; display: flex;">-->
        <!--<input class="form-control flex-grow-1 date-text-input" v-model="startDatePersian" readonly="true"-->
        <!--@click="toggleStartDatePicker">-->
        <!--</date-picker>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class=" d-inline-block mx-1 mb-3">-->
        <!--<div class="input-group round">-->
        <!--<div class="input-group-prepend">-->
        <!--<span class="input-group-text">تا تاریخ</span>-->
        <!--</div>-->
        <!--<date-picker type="date" class="date-picker" format="jYYYY-jMM-jDD" :auto-submit="true"-->
        <!--@input="onEndDatePicked" ref="datePickerEnd"-->
        <!--style="flex: 1; display: flex;">-->
        <!--<input class="form-control flex-grow-1 date-text-input" v-model="endDatePersian" readonly="true"-->
        <!--@click="toggleEndDatePicker">-->
        <!--</date-picker>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="d-inline-block mx-3">-->
        <!--<button class="btn btn-primary" @click="getReport">استعلام</button>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <hr/>

        <div class="row">

            <div class="col-12 text-center">
                <div v-if="pakets === undefined || pakets === null" class="col-lg-12 text-center mt-5 mb-3">
                    <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
                </div>
                <div class="table-responsive" v-else>
                    <table class="table table-hover table-striped">
                        <thead>
                        <tr>
                            <th class="text-center text-nowrap">تاریخ سند</th>
                            <th class="text-center text-nowrap">شماره سند</th>
                            <th class="text-center text-nowrap">تاریخ و ساعت ارسال</th>
                            <th class="text-center text-nowrap">شماره رفرنس</th>
                            <th class="text-center text-nowrap">آی دی</th>
                            <th class="text-center text-nowrap">وضعیت</th>
                            <th class="text-center text-nowrap">بروز رسانی</th>
                            <th class="text-center text-nowrap">خطاها</th>
                            <th class="text-center text-nowrap">حذف از لیست</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in pakets">
                            <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                            <td >{{item.voucher.fDate}}</td>
                            <td >{{item.voucher.voucherNumber}}</td>
                            <td class="text-center">{{item.fDate}}</td>
                            <td class="text-center">{{item.referenceNumber}}</td>
                            <td class="text-center">{{item.uid}}</td>
                            <td class="text-center">
                                {{item.voucher.result}}
                                {{item.voucher.result !== null && item.voucher.result==="IN_PROGRESS" ? "("+ "درحال بررسی حداقل 5 دقیقه صبر کنید" + ")":""}}
                                {{item.voucher.result !== null && item.voucher.result==="FAILED" ? "("+ "فاکتور ایراد دارد" + ")":""}}
                                {{item.voucher.result !== null && item.voucher.result==="ارسال شده" ? "("+ "برای مشاهده وضعیت، 5 دقیقه بعد از ارسال بروزرسانی کنید" +
                                ")":""}}
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-success" @click="onRefreshClicked(item.referenceNumber)"><i class="fa fa-refresh"></i></button>
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-danger" @click="onErrorDataClicked(item.referenceNumber)"><i class="fa fa-eraser"></i></button>
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-danger" @click="onDeleteClicked(item.referenceNumber)"><i class="fa fa-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </div>

                <!--<div v-if="pakets.length < dataCount" class="col-lg-12 text-center mb-3" @click="getVouchers">-->
                    <!--<button class="btn btn-success">نمایش اسناد بیشتر</button>-->
                <!--</div>-->
            </div>

        </div>

        <!---------------------- MODALS ------------------------------>
        <div class="modal fade" ref="errorData" id="errorData" tabindex="-1" role="dialog" aria-labelledby="errorTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="errorTitle">خطاهای سامانه</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <h6 class="text-center mt-5">لطفا پس از رفع خطاهای یاد شده و اصلاح فاکتور، مجددا فاکتور را به سامانه مالیاتی ارسال نمایید</h6>
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class=" text-nowrap">کد خطا</th>
                                    <th class="text-center text-nowrap">متن خطا</th>
                                    <th class="text-center text-nowrap">نوع خطا</th>
                                </tr>
                                </thead>
                                <tbody v-if="errorDatas !== undefined">
                                <tr v-for="(item,index) in errorDatas">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td>{{item.code}}</td>
                                    <td class="text-center">{{item.message}}</td>
                                    <td class="text-center">{{item.isWarning ?
                                        "اخطار-Warning"
                                        :
                                        "خطا-Error"
                                        }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitleEdit">محصولات فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!--<div class="modal-body" id="printMe">-->
                    <div class="modal-body">
                        <div class="table-responsive" id="printMe" v-if="voucher !== undefined">
                            <h6 class="text-center">
                                {{voucher.voucher !== undefined ? voucher.voucher.receiveOutSourceName : ''}}
                                تاریخ
                                {{ voucher.voucher !== undefined ? voucher.voucher.persianDate : '' }}
                                سند شماره
                                {{ voucher.voucher !== undefined ? voucher.voucher.voucherNumber : ''}}
                            </h6>
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class=" text-nowrap">نام محصول</th>
                                    <th class="text-center text-nowrap">تعداد</th>
                                    <th class="text-center text-nowrap">قیمت</th>
                                    <th class="text-center text-nowrap">تخفیف</th>
                                    <th class="text-center text-nowrap">جمع</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in voucher.products">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td>{{item.productName}}</td>
                                    <td class="text-center  pb-0">
                                        {{item.unitVal}}
                                    </td>
                                    <td class="text-center pb-0">
                                        {{item.salesPrice.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{item.discount.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{((item.salesPrice-item.discount) * item.unitVal).toLocaleString()}}
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <h4 class="text-center mt-5"
                            v-if="voucher.products !== undefined && voucher.products.length < 1">محصولی ثبت نشده
                            است!</h4>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تخفیف فاکتور</span>
                            </div>
                            <span class="input-group-text">{{voucher.voucher !== undefined  && voucher.voucher.discount !== undefined? voucher.voucher.discount.toLocaleString() : 0}}</span>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fa fa-pencil"></i></span>
                            </div>
                            <input class="form-control" type="text" v-if="voucher.voucher !== undefined" v-model="voucher.voucher.description"
                                   placeholder="توضیحات" disabled>
                        </div>
                        <div class="text-center w-100 p-3 text-bold">
                            <span>وضعیت مالیاتی : </span>
                            <span v-if="voucher.voucher !== undefined">{{voucher.voucher.result}}</span>
                            <button v-if="voucher.voucher !== undefined && voucher.voucher.result === 'FAILED'" type="button" class="btn btn-danger" title="مشاهده خطاها"
                                    @click="onErrorDataClicked(voucher.voucher.id)"><i class="fa fa-eraser"></i></button>
                        </div>
                        <!--<div class="text-center w-100 p-3 text-bold">-->
                        <!--<span>قابل پرداخت : </span>-->
                        <!--<span v-if="voucher.voucher !== undefined">{{(parseInt(voucher.voucher.price)).toLocaleString()}}</span>-->
                        <!--<span>باقیمانده : </span>-->
                        <!--<span v-if="voucher.voucher !== undefined">{{(parseInt(voucher.voucher.price) -  voucher.payments.reduce( (acc, itt) => { return acc += itt.price; }, 0)).toLocaleString()}}</span>-->
                        <!--</div>-->
                        <!--<hr class=" w100"/>-->
                        <!--<h5 class="w-100 text-center">لیست پرداختها</h5>-->
                        <!--<div class="w-100 " v-if="voucher.payments !== undefined">-->
                        <!--<table class="table table-hover table-striped">-->
                        <!--<thead>-->
                        <!--<tr>-->
                        <!--<th class=" text-nowrap text-center">مبلغ</th>-->
                        <!--<th class=" text-nowrap text-center">تاریخ</th>-->
                        <!--<th class="text-center">توضیحات</th>-->
                        <!--</tr>-->
                        <!--</thead>-->
                        <!--<tbody v-if="voucher !== undefined">-->
                        <!--<tr v-for="(item,index) in voucher.payments">-->
                        <!--&lt;!&ndash;<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>&ndash;&gt;-->
                        <!--<td>{{item.price.toLocaleString()}}</td>-->
                        <!--<td class="text-nowrap">{{item.fdate}}</td>-->
                        <!--<td class="text-center">-->
                        <!--{{item.code}}-->
                        <!--</td>-->
                        <!--</tr>-->
                        <!--</tbody>-->
                        <!--</table>-->
                        <!--</div>-->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                                class="fa fa-print"></i></button>
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-danger" @click="onTaxSendClicked(voucher.voucher)" v-if="voucher.voucher !== undefined">ارسال مجدد</button>
                        <!--<button type="button" class="btn btn-primary" @click="onModalEditClicked">ویرایش</button>-->
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import EventBus from "../../_framework/event-bus.js";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect"
    import VueHtmlToPaper from 'vue-html-to-paper';
    import html2canvas from 'html2canvas';


    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'sentFactors',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {
                errorDatas: [],
                vouchers: [],
                voucher: {},
                overallAmount: 0,
                queryParams: {
                    fromDateTime: null,
                    toDateTime: null,
                },
                dataCount: 0,

                listView: false,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                startDatePersian: "",
                endDatePersian: "",
                providers: [],
                selectedProvider: 0,
                pakets: [],
                isSending: false,
                isLoading: false,

            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);

            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            this.getPakets();
            // this.getProviders();
        },
        methods: {
            getPakets() {
                this.pakets = [];
                this.isLoading = true;
                new BaseService('TaxService', '/GetPacketResponse').getList().then(response => {
                    this.pakets = response.data.value;
                    // console.log(this.pakets)
                    if (this.pakets !== null) {
                        for (let item of this.pakets) {
                            item.fDate = Moment(item.date, 'YYYY-MM-DD HH:mm').format('jDD jMMMM jYYYY HH:mm');
                            if(item.voucher !== null){
                                item.voucher.fDate = Moment(item.voucher.voucherDate, 'YYYY-MM-DD HH:mm').format('jDD jMMMM jYYYY');
                            }
                        }
                    }
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            showVoucher(id) {
                this.overallAmount = 0;
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    for (let item of this.voucher.products) {
                        this.overallAmount += item.unitVal;
                    }
                    if (this.voucher.payments != undefined && this.voucher.payments != null) {
                        for (let i of this.voucher.payments) {
                            i.fdate = Moment(i.check.checkDate, 'YYYY-MM-DD HH:mm').format('jYYYY/jMM/jDD-HH:mm');
                        }
                    }
                    let todayDate = new Date().toJSON().slice(0, 10);
                    this.voucher.voucher.voucherDate = this.voucher.voucher.voucherDate.slice(0, 10);
                    this.voucher.pdate = this.voucher.voucher.persianDate;
                    this.voucher.vNum = this.voucher.voucher.voucherNumber;
                    this.voucher.name = this.voucher.voucher.receiveOutSourceName;
                    $("#voucherData").modal("show");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                })
            },
            onRefreshClicked(referenceNumber) {
                if (!this.isSending) {
                    this.isSending = true;
                    this.isLoading = true;
                    new BaseService('TaxService', `/InquiryByReferenceId/${referenceNumber}`).getList().then(response => {
                        this.onErrorDataClicked(referenceNumber);
                        this.getPakets();
                        this.isSending = false;
                        this.isLoading = false;
                    }).catch(error => {
                        this.isLoading = false;
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            onErrorDataClicked(referenceNumber) {
                new BaseService('TaxService', `/GetErrorData/${referenceNumber}`).getList().then(response => {
                    this.errorDatas = response.data.value;
                    if (this.errorDatas !== null && this.errorDatas.length > 0) {

                        this.$router.push({
                            name: 'errorData',
                            params: {
                                errorData : this.errorDatas,
                                path:"sentFactors"
                            }
                        });



                        // console.log($("#errorData"));
                        // // console.log(this.$refs.errorData);
                        // // this.$refs.errorData.show();
                        // $("#errorData").modal({
                        //     backdrop: true, // نمایش پس‌زمینه
                        //     keyboard: true, // اجازه بستن با کلید Esc
                        //     show: false,    // نمایش به‌صورت پیش‌فرض
                        // });
                        // this.$nextTick(() => {
                        //     $("#errorData").modal("show");
                        // });
                        // // $("#errorData").modal("show");
                    } else {
                        this.$noty.success("خطایی یافت نشد، مجددا بروز رسانی فرمائید");
                    }
                }).catch(error => {
                    // error
                    console.log(error.message)
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            onDeleteClicked(referenceNumber){
                if(confirm("آیا میخواهید این سند را از لیست ارسال شده ها حذف کنید و مجدد ارسال کنید؟")){
                    new BaseService('TaxService', `/DeleteData/${referenceNumber}`).getList().then(response => {
                        this.getPakets();
                    }).catch(error => {
                        // error
                        console.log(error.message)
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            // onPrintClicked() {
            //     html2canvas(document.getElementById("printMe")).then(function (canvas) {
            //         // document.body.appendChild(canvas);
            //         const dataURL = canvas.toDataURL();
            //         const a = document.getElementById("printPaper"); //Create <a>
            //
            //
            //         a.width = dataURL.naturalWidth;
            //         a.height= dataURL.naturalHeight*3;
            //
            //         // a.getContext('2d');
            //         // a.imageSmoothingEnabled = false;
            //
            //
            //
            //         a.href = "data:image/" + dataURL; //Image Base64 Goes here
            //         let d = new Date();
            //         let dt = d.getMilliseconds();
            //         let r = Math.floor(Math.random() * 1000);
            //         a.download = "Image" + r + dt + ".jpg";
            //         a.click();
            //         // a.hidden;
            //     });
            // },
            onTaxSendClicked(item) {
                $("#loading").show();
                new BaseService('TaxService', `/MakeReady/${item.id}`).getList().then(response => {
                    this.$noty.success("فاکتور با موفقیت ارسال شد. از بخش پیگیری آخرین وضعیت فاکتورها را مشاهده کنید");
                    $("#voucherData").modal("hide");
                    this.getPakets();
                    // if(confirm("فاکتور آماده ارسال میباشد. آیا ارسال شود؟")) {
                    //     axios.defaults.baseURL = Constants.TAX_SERVICE_URL;
                    //     // axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem("token_mobile");
                    //     axios.post('TestBusiness/CreateInvoices', response.data.value).then(resp => {
                    //         this.$noty.success("فاکتور با موفقیت ارسال شد. از بخش پیگیری آخرین وضعیت فاکتورها را مشاهده کنید");
                    //     }).catch(err => {
                    //         Utils.handleErrorWithNotification(err.response.message, this.$noty);
                    //     });
                    // }


                    $("#loading").hide();
                }).catch(error => {
                    $("#loading").hide();
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            },
            getVouchers(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.vouchers = [];
                } else {
                    this.queryParams.pageIndex++;
                }
                $("#loading").show();
                new BaseService('reports', '/getvoucherreport').getList(this.queryParams).then(response => {
                    let newItems = response.data.data;
                    for (let item of newItems) {
                        item.voucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                    this.vouchers.push.apply(this.vouchers, newItems);
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(e, index) {
                this.overallAmount = 0;
                let id = this.vouchers[index].id;
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    for (let item of this.voucher.products) {
                        this.overallAmount += item.unitVal;
                    }
                    if (this.voucher.payments != undefined && this.voucher.payments != null) {
                        for (let i of this.voucher.payments) {
                            i.fdate = Moment(i.check.checkDate, 'YYYY-MM-DD HH:mm').format('jYYYY/jMM/jDD-HH:mm');
                        }
                    }
                    let todayDate = new Date().toJSON().slice(0, 10);
                    this.voucher.voucher.voucherDate = this.voucher.voucher.voucherDate.slice(0, 10);
                    this.voucher.pdate = this.voucher.voucher.persianDate;
                    this.voucher.vNum = this.voucher.voucher.voucherNumber;
                    this.voucher.name = this.voucher.voucher.receiveOutSourceName;

                    if (this.voucher.voucher.voucherDate <= todayDate) {

                        $("#voucherDataEdit").modal("show");
                    } else {

                        $("#voucherData").modal("show");
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                })
            },
            getProviders() {
                this.queryParams = {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    types: 3
                };
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.providers = response.data.data;
                    let allPro = {
                        id: 0,
                        outSourceName: "همه مشتری ها"
                    };
                    this.providers.push(allPro);
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
                this.queryParams = {
                    pageSize: 12,
                    pageIndex: 0,
                    name: "",
                    types: 2
                };

            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                this.queryParams.fromDateTime = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.queryParams.toDateTime = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
                // this.getReport();
            },
            resetStartDate() {
                this.fromDate = '';
                this.startDatePersian = '';
                this.queryParams.fromDateTime = null;
                this.queryParams.toDateTime = null;
            },
            resetEndDate() {
                this.toDate = '';
                this.endDatePersian = '';
            },
            getReport() {
                // this.queryParams = {
                //     fromDateTime: this.fromDate,
                //     toDateTime: this.toDate,
                // };
                console.log(this.queryParams)
                if (!this.isSending) {
                    this.isSending = true;
                    this.isLoading = true;
                    new BaseService('TaxService', '/InquiryByTimeRange').getList(this.queryParams).then(response => {

                        this.getPakets();
                        this.isSending = false;
                        this.isLoading = false;
                    }).catch(error => {
                        this.isLoading = false;
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }

            },
            onChange(val) {
                this.selectedProvider = val.id;
                this.queryParams = {
                    reciveId: this.selectedProvider,
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1
                };
                new BaseService('reports', '/getvoucherreport').getList(this.queryParams).then(response => {
                    this.vouchers = response.data.data;
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                    for (let item of this.vouchers) {
                        item.voucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });


            },

            onModalEditClicked() {
                if (localStorage.getItem("companyPostName") === 'مدیر') {
                    $("#voucherDataEdit").modal("hide");
                    // if (this.voucher.type === "buy") {
                    // console.log(this.voucher)
                    let newVoucher = this.voucher.voucher;
                    newVoucher.voucherProductDto = this.voucher.products;
                    newVoucher.overallAmount = 0;
                    for (let pro of newVoucher.voucherProductDto) {
                        newVoucher.overallAmount += pro.unitVal;
                        newVoucher.sellPrice = pro.salesPrice;
                    }
                    newVoucher.overallPrice = newVoucher.price;

                    let obj = {
                        name: 'sell',
                        params: {
                            id: this.voucher.voucher.receiveOutSourceId,
                            outSourceName: this.voucher.voucher.receiveOutSourceName,
                            voucher: newVoucher,
                            fromEdit: true
                        }
                    };
                    this.$router.push(obj);
                    // } else {
                    //     let obj = {
                    //         name: 'sell',
                    //         params: {
                    //             voucher: this.voucher
                    //         }
                    //     };
                    //     this.$router.push(obj);
                    // }
                } else {
                    this.$noty.success("با عرض پوزش، شما مجاز به ویرایش رسید نیستید.");
                }
            },
            onVoucherRemoveClicked(item) {
                if (confirm("در صورت تایید اطلاعات دریافت و کالاهای آن حذف میشوند. آیا حذف فاکتور را تایید میکنید؟")) {
                    new BaseService('Voucher', `/DeleteVoucher/${item.id}`).create().then(response => {
                        this.$noty.success('سند با موفقیت حذف شد');
                        this.getVouchers(-1);
                        $("#voucherDataEdit").modal("hide");
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    });
                }
            },
            onPaymentClicked(item) {
                let remain = parseInt(item.voucher.price) - item.payments.reduce((acc, itt) => {
                    return acc += itt.price;
                }, 0);
                item.voucher.overallPrice = remain;
                item.voucher.overallAmount = 0;
                for (let p of item.products) {
                    item.voucher.overallAmount += p.unitVal;
                }
                if (!isNaN(item.voucher.overallPrice) && !isNaN(item.voucher.overallAmount)) {
                    item.voucher.voucherProductDto = item.products;
                    $("#voucherDataEdit").modal("hide");
                    let obj = {
                        name: 'payment',
                        path: '/payment',
                        params: {
                            voucher: item.voucher,
                            type: "sell"
                        }
                    };


                    this.$router.push(obj);
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }
            },


        },
        // beforeRouteLeave(to, from, next) {
        //     $(window).unbind('scroll');
        //     if ($("#voucherData").hasClass("show")) {
        //         $("#voucherData").modal("hide");
        //         next(false);
        //     } else {
        //         if ($("#voucherDataEdit").hasClass("show")) {
        //             $("#voucherDataEdit").modal("hide");
        //             next(false);
        //         } else {
        //             next();
        //         }
        //     }
        //
        //
        // },
    }
</script>